import React, { useEffect, useState } from "react";
import { Dropdown, Menu, Table } from "antd";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Header from "../../Header";
import Sidebar from "../../Sidebar";

// import Invoice_HeaderContent from "./Invoice_HeaderContent";
import {
  imagesend,
  pdficon,
  pdficon3,
  pdficon5,
  plusicon,
  refreshicon,
  searchnormal,
  // searchnormal,
} from "../../imagepath";
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import { getAllInvoices } from "../../../connections/getAllInvoices";

import {
  formatDateTime,
  generateCsv,
  handlePrintInvoice,
  handleShowJson,
} from "../../../utils/constant/constant";
import { deleteInvoice } from "../../../connections/deleteInvoice";
import { toast } from "react-toastify";
import useDebounce from "../../../utils/hooks";
import { getPatientsList } from "../../../connections/getPatientsList";
import Select from "react-select";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { getAllDepartments } from "../../../connections/getAllDepartments";

const InvoiceList = () => {
  const [invoiceId, setInvoiceId] = useState(null);
  const [totalCollection, setTotalCollection] = useState(null);
  // const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  // const [searchTerm, setSearchTerm] = useState("");
  const [sortColumns, setSortColumns] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [filter, setFilter] = useState({});
  const [showCollection, setShowCollection] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const location = useLocation();
  // const { startDate, endDate, department } = location?.state || {};
  // console.log(location);
  const {
    user: { user },
  } = useSelector((store) => store);

  const debouncedInputValue = useDebounce(inputValue, 1000);
  const { data: getSearchedPatient } = useQuery({
    queryKey: ["getAdmissionsList", debouncedInputValue, 1, 50],
    queryFn: () => getPatientsList(user?.token, debouncedInputValue, 1, 50),
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    enabled: !!debouncedInputValue,
  });
  const {
    data: getAllInvoicesData,
    isLoading: invoiceLoader,
    refetch: refetchInvoice,
    isRefetching,
  } = useQuery({
    queryKey: [
      "getAllInvoices",
      page,
      pageSize,
      sortColumns,
      sortOrder,
      filter?.department_id,
    ],
    queryFn: () =>
      getAllInvoices(
        user?.token,
        null,
        page,
        pageSize,
        sortColumns,
        sortOrder,
        filter
      ),

    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
  const navigate = useNavigate();
  const { data: getDepartmentData, isLoading: deptLoading } = useQuery({
    queryKey: ["getAllDepartments", page, pageSize],
    queryFn: () => getAllDepartments(user?.token, null, 1, 1000),
    refetchOnWindowFocus: false, // Don't refetch when window regains focus
    refetchOnReconnect: false, // Don't refetch when reconnecting
  });
  // const onSelectChange = (newSelectedRowKeys) => {
  //   console.log("selectedRowKeys changed: ", selectedRowKeys);
  //   setSelectedRowKeys(newSelectedRowKeys);
  // };
  // const handleSearchInput = (e) => {
  //   e.preventDefault();
  //   setSearchTerm(e?.target?.value);
  // };
  // const rowSelection = {
  //   selectedRowKeys,
  //   onChange: onSelectChange,
  // };
  const handleTableChange = async (filters, sorter) => {
    // Extract sorting details
    const sortColumn = sorter.field;
    const sortOrder =
      sorter.order === "ascend"
        ? "asc"
        : sorter.order === "descend"
        ? "desc"
        : null;
    // console.log("sorter", sorter);
    setSortColumns(sortColumn);
    setSortOrder(sortOrder);
  };
  const handleFilterChange = (key, value) => {
    setFilter((prev) => {
      const updatedFilter = { ...prev };
      if (value === null || value === "" || !value) {
        delete updatedFilter[key];
      } else {
        updatedFilter[key] = value;
      }

      return updatedFilter;
    });
  };
  const handleSubmitFilter = async () => {
    console.log("btn click done", filter);
    const data = await refetchInvoice(
      user?.token,
      null,
      page,
      pageSize,
      sortColumns,
      sortOrder,
      filter
    );
    console.log(data, "data");
    setTotalCollection(data?.data?.meta?.total_collection);
    setShowCollection(true);
  };
  const handleResetFilter = () => {
    setFilter({});
    setShowCollection(false);
    setTimeout(() => {
      const refetchBtn = document.getElementById("refetch-btn");
      if (refetchBtn) {
        refetchBtn.click();
      }
    }, 100);
  };
  const handleInputChange = (newInputValue) => {
    setInputValue(newInputValue);
  };
  const handleLinkClick = () => {
    // Save current filter state and table settings
    const filterState = {
      filter,
      showFilter,
      showCollection,
      page,
      pageSize,
      sortColumns,
      sortOrder,
      // patientId,
    };
    sessionStorage.setItem("invoiceListState", JSON.stringify(filterState));
    // navigate(`/admin/invoice-details/${patientId}`);
  };
  const columns = [
    {
      title: "Id",
      dataIndex: "id",
      sorter: true,
    },
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Patient",
      dataIndex: "patient",
      render: (_, record) => (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: "4px",
          }}
        >
          <Link
            to={`/admin/patient/${record?.patient?.id}`}
            style={{ textDecoration: "underline" }}
            onClick={() => handleLinkClick()}
          >
            {record?.patient?.full_name}
          </Link>
          <span style={{ fontSize: "12px" }}>Mob. {record?.patient?.mobile}</span>
        </div>
      ),
    },
    {
      title: "Inv. UID",
      dataIndex: "uid",
      render: (_,record) => (
             <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: "4px",
          }}
        >
          <span>{record?.uid}</span>
          <span style={{ fontSize: "12px" }}>status. {record?.status}</span>

        </div>
      )
    },
  
    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   sorter: true,
    // },
    {
      title: "Invoice Type",
      dataIndex: "invoice_type",
      sorter: true,
    },
    {
      title: "Department",
      dataIndex: "department",
      render: (_, record) => (
        <Link
          to={`/department_details/${record?.department?.id}`}
          onClick={() => handleLinkClick()}
          style={{ textDecoration: "underline" }}
        >
          {record?.department?.name}
        </Link>
        //    <Link >
        //    {text}
        //  </Link>
      ),
    },
    // {
    //   title: "Total",
    //   dataIndex: "total",
    // },
    {
      title: "Grand Total",
      dataIndex: "grand_total",
      render: (_,record) => (
             <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: "4px",
          }}
        >
          <span>{record?.grand_total}</span>
          <span style={{ fontSize: "12px" }}>total. {record?.total}</span>

        </div>
      )
    },
    {
      title: "Generated At",
      dataIndex: "generated_at",
      sorter: true,
      render: (date) => <>{formatDateTime(date)}</>,
    },

    {
      title: "Generated By",
      dataIndex: "generated_by",
    },
    
    // {
    //   title: "Created At",
    //   dataIndex: "created_at",
    //   sorter: true,
    //   render: (date) => <>{formatDateTime(date)}</>,
    // },
    // {
    //   title: "Updated At",
    //   dataIndex: "updated_at",
    //   sorter: true,
    //   render: (date) => <>{formatDateTime(date)}</>,
    // },
    // {
    //   title: "",
    //   dataIndex: "FIELD8",
    //   render: (_, record) => (
    //     <>
    //       <div className="text-end">
    //         <div className="dropdown dropdown-action">
    //           <Link
    //             to="#"
    //             className="action-icon dropdown-toggle"
    //             data-bs-toggle="dropdown"
    //             aria-expanded="false"
    //           >
    //             <i className="fas fa-ellipsis-v" />
    //           </Link>
    //           <div className="dropdown-menu dropdown-menu-end">
    //             <Link
    //               className="dropdown-item"
    //               to={`/admin/invoice-details/${record?.id}`}
    //               onClick={() => handleLinkClick()}
    //             >
    //               <i className="fa-regular fa-eye m-r-5" />
    //               View
    //             </Link>
    //             <button
    //               className="dropdown-item"
    //               onClick={() => {
    //                 navigate("/admin/edit-invoice", { state: record });
    //                 handleLinkClick();
    //               }}
    //             >
    //               <i className="far fa-edit me-2" />
    //               Edit
    //             </button>
    //             <Link
    //               className="dropdown-item"
    //               onClick={() => setInvoiceId(record?.id)}
    //               data-bs-toggle="modal"
    //               data-bs-target="#delete_patient"
    //             >
    //               <i className="fa fa-trash-alt m-r-5"></i> Delete
    //             </Link>
    //           </div>
    //         </div>
    //       </div>
    //     </>
    //   ),
    // },
    {
      title: "",
      dataIndex: "FIELD8",
      render: (_, record) => (
        <Dropdown
          overlay={
            <Menu>
              <Menu.Item key="view">
                <Link
                  to={`/admin/invoice-details/${record?.id}`}
                  onClick={() => handleLinkClick()}
                >
                  <i className="fa-regular fa-eye m-r-5" /> View
                </Link>
              </Menu.Item>
              <Menu.Item
                key="edit"
                onClick={() => {
                  navigate("/admin/edit-invoice", { state: record });
                  handleLinkClick();
                }}
              >
                <i className="far fa-edit me-2" /> Edit
              </Menu.Item>
              <Menu.Item
                className="dropdown-item"
                to="#"
                data-bs-toggle="modal"
                data-bs-target="#delete_patient"
                key="delete"
                onClick={() => setInvoiceId(record?.id)}
              >
                <i className="fa fa-trash-alt m-r-5" /> Delete
              </Menu.Item>
            </Menu>
          }
          trigger={["click"]}
          placement="bottomRight"
        >
          <Link
            to="#"
            style={{ marginRight: 5 }}
            className="action-icon"
            // data-bs-toggle="dropdown"
            // aria-expanded="false"
          >
            <i className="fas fa-ellipsis-v" />
          </Link>
        </Dropdown>
      ),
    },
  ];
  const departmentOption = getDepartmentData?.payload?.departments
    ?.filter((item) => item.active)
    .map((item) => ({
      value: item.id,
      label: item.name,
    }));
  const invoiceTypeOption = [
    { label: "Consultancy", value: 1 },
    { label: "Tests", value: 2 },
    { label: "Pharmacy", value: 3 },
    { label: "Daycare", value: 4 },
    { label: "Procedure", value: 5 },
  ];
  const modeOfPayment = [
    { label: "Cheque", value: "Cheque" },
    { label: "Card", value: "Card" },
    { label: "UPI", value: "UPI" },
    { label: "Cash", value: "Cash" },
  ];
  const statusOptions = [
    { label: "Generated", value: 1 },
    { label: "Cancelled", value: 2 },
    { label: "Refunded", value: 3 },
  ];
  const handlePageChange = (newPage, newPageSize) => {
    setPage(newPage);
    setPageSize(newPageSize);
  };
  const handleDeleteInvoice = async (e) => {
    e.preventDefault();
    const data = await deleteInvoice(user?.token, invoiceId);
    if (data.status.status === "SUCCESS") {
      toast.success("Invoice Delete Successfully");
      refetchInvoice();
    }
  };
  useEffect(() => {
    if (!showFilter) {
      setShowCollection(false);
      setFilter({});
      setTimeout(() => {
        const refetchBtn = document.getElementById("refetch-btn");
        if (refetchBtn) {
          refetchBtn.click();
        }
      }, 100);
    }
    if (!showFilter && Object?.keys(filter)?.length > 0) {
      setShowCollection(false);
      refetchInvoice();
    }
    setTotalCollection(getAllInvoicesData?.meta?.total_collection);
  }, [showFilter]);
  const handleInitialFilter = () => {
    return new Promise((resolve, reject) => {
      try {
        const savedState = sessionStorage.getItem("filterInvoice");

        if (savedState) {
          const { startDate, endDate, department } = JSON.parse(savedState);
          console.log(
            startDate,
            endDate,
            department,
            "state from dash",
            location.state
          );

          setShowFilter(true);
          const newFilter = {
            generated_start_date: startDate,
            generated_end_date: endDate,
            department_id: department,
            // invoice_type: department,
          };

          setFilter(newFilter);
          setTimeout(() => {
            resolve(true);
          }, 10);
        } else {
          resolve(false);
        }
      } catch (error) {
        console.error("Failed to parse sessionStorage filterInvoice:", error);
        reject(error);
      }
    });
  };

  useEffect(() => {
    handleInitialFilter().then((res) => {
      console.log(res, " this res ");
      sessionStorage.removeItem("filterInvoice");
      // Wait for state updates and trigger filter button click
      setTimeout(() => {
        const filterBtn = document.getElementById("filter-btn");
        if (filterBtn) {
          console.log("btn click start");
          filterBtn.click();
        }
      }, 200);
    });
    const savedState = sessionStorage.getItem("invoiceListState");
    if (savedState) {
      const {
        filter: savedFilter,
        showFilter: savedShowFilter,
        showCollection: savedShowCollection,
        page: savedPage,
        pageSize: savedPageSize,
        sortColumns: savedSortColumns,
        sortOrder: savedSortOrder,
      } = JSON.parse(savedState);
      setFilter(savedFilter);
      setShowFilter(savedShowFilter);
      setShowCollection(savedShowCollection);
      setPage(savedPage);
      setPageSize(savedPageSize);
      setSortColumns(savedSortColumns);
      setSortOrder(savedSortOrder);

      // Clear the saved state
      sessionStorage.removeItem("invoiceListState");
      // Trigger refetch with saved filter
      if (Object.keys(savedFilter).length > 0) {
        setTimeout(() => {
          refetchInvoice();
        }, 100);
      }
    }
  }, []);
  console.log(
    getSearchedPatient?.payload?.patients?.map((patient) => ({
      label: patient.full_name,
      value: patient.id,
    }))
  );
  console.log(departmentOption);
  return (
    <>
      <Header />
      <Sidebar activeClassName="invoice-list" />
      <>
        <div className="page-wrapper">
          <div className="content">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/admin/invoice-list">Invoices </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">Invoice List</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            {/* <Invoice_HeaderContent /> */}
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-table">
                  <div className="card-body">
                    {/* {filter } */}
                    <div className="page-table-header mb-2">
                      <div className="row align-items-center">
                        {showFilter && (
                          <div className="col filter-container">
                            <div className="doctor-table-blk">
                              <h3 style={{ marginBottom: 2 }}>Filter</h3>
                            </div>
                            <div className="row mt-2">
                              <div className="col-12 col-md-4 col-lg-2">
                                <div className="form-group local-forms">
                                  <label>
                                    <img
                                      width="15px"
                                      height="15px"
                                      style={{ marginRight: 2 }}
                                      src={searchnormal}
                                      alt="#"
                                    />
                                    Search
                                  </label>
                                  <input
                                    value={filter?.q || ""}
                                    onChange={(e) =>
                                      handleFilterChange("q", e.target.value)
                                    }
                                    className="form-control"
                                    type="text"
                                    placeholder="Search here"
                                  />
                                </div>
                              </div>

                              <div className="col-12 col-md-4 col-lg-2">
                                <div className="form-group local-forms">
                                  <label>
                                    Patient
                                    {/* <span className="login-danger">*</span> */}
                                  </label>
                                  <Select
                                    inputValue={inputValue}
                                    onInputChange={handleInputChange}
                                    onChange={(e) =>
                                      handleFilterChange(
                                        "patient_id",
                                        e ? e.value : null
                                      )
                                    }
                                    isClearable
                                    placeholder="Search"
                                    filterOption={false}
                                    options={
                                      getSearchedPatient?.payload?.patients?.map(
                                        (patient) => ({
                                          label:
                                            patient.full_name +
                                            " " +
                                            `(${patient?.mobile})`,
                                          value: patient.id,
                                        })
                                      ) || []
                                    }
                                    menuPortalTarget={document.body}
                                    styles={{
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                      control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        borderColor: state.isFocused
                                          ? "#007A99"
                                          : "rgba(46, 55, 164, 0.1)",
                                        boxShadow: state.isFocused
                                          ? "0 0 0 1px #007A99"
                                          : "none",
                                        "&:hover": {
                                          borderColor: "rgba(46, 55, 164, 0.1)",
                                        },
                                        borderRadius: "10px",
                                        fontSize: "14px",
                                        // minHeight: "45px",
                                      }),
                                      dropdownIndicator: (base, state) => ({
                                        ...base,
                                        transform: state.selectProps.menuIsOpen
                                          ? "rotate(-180deg)"
                                          : "rotate(0)",
                                        transition: "250ms",
                                        width: "35px",
                                        height: "38px",
                                      }),
                                    }}
                                    id="search-commodity"
                                    components={{
                                      IndicatorSeparator: () => null,
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="col-12 col-md-4 col-lg-2">
                                <div className="form-group local-forms">
                                  <label>Patient Name</label>
                                  <input
                                    value={filter?.name || ""}
                                    onChange={(e) =>
                                      handleFilterChange("name", e.target.value)
                                    }
                                    className="form-control"
                                    type="text"
                                    placeholder="name"
                                  />
                                </div>
                              </div>
                              <div className="col-12 col-md-4 col-lg-2">
                                <div className="form-group local-forms">
                                  <label>Mobile</label>
                                  <input
                                    value={filter?.mobile || ""}
                                    onChange={(e) =>
                                      handleFilterChange(
                                        "mobile",
                                        e.target.value
                                      )
                                    }
                                    className="form-control"
                                    type="text"
                                    placeholder="mobile"
                                  />
                                </div>
                              </div>
                              <div className="col-12 col-md-4 col-lg-2">
                                <div className="form-group local-forms">
                                  <label>Invoice Uid</label>
                                  <input
                                    value={filter?.uid || ""}
                                    onChange={(e) =>
                                      handleFilterChange("uid", e.target.value)
                                    }
                                    className="form-control"
                                    type="text"
                                    placeholder="uid"
                                  />
                                </div>
                              </div>
                              <div className="col-12 col-md-4 col-lg-2">
                                <div className="form-group local-forms">
                                  <label>
                                    Generated start date
                                    {/* <span className="login-danger">*</span> */}
                                  </label>
                                  <input
                                    type="date"
                                    value={filter?.generated_start_date || ""}
                                    onChange={(e) =>
                                      handleFilterChange(
                                        "generated_start_date",
                                        e.target.value
                                      )
                                    }
                                    className="form-control"
                                  />
                                </div>
                              </div>
                              <div className="col-12 col-md-4 col-lg-2">
                                <div className="form-group local-forms">
                                  <label>
                                    Generated end date
                                    {/* <span className="login-danger">*</span> */}
                                  </label>
                                  <input
                                    type="date"
                                    value={filter?.generated_end_date || ""}
                                    onChange={(e) =>
                                      handleFilterChange(
                                        "generated_end_date",
                                        e.target.value
                                      )
                                    }
                                    className="form-control"
                                  />
                                </div>
                              </div>
                              <div className="col-12 col-md-4 col-lg-2">
                                <div className="form-group local-forms">
                                  <label>
                                    Invoice type
                                    {/* <span className="login-danger">*</span> */}
                                  </label>
                                  <Select
                                    value={
                                      invoiceTypeOption.find(
                                        (option) =>
                                          option.value === filter.invoice_type
                                      ) || null
                                    }
                                    onChange={(e) =>
                                      handleFilterChange(
                                        "invoice_type",
                                        e?.value
                                      )
                                    }
                                    name="invoice_type"
                                    options={invoiceTypeOption}
                                    placeholder="Select invoice type"
                                    components={{
                                      IndicatorSeparator: () => null, // Hide separator line between the dropdown indicator and the control
                                    }}
                                    styles={{
                                      control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        // zIndex: 99999,
                                        borderColor: state.isFocused
                                          ? "none"
                                          : "2px solid rgba(46, 55, 164, 0.1)",
                                        boxShadow: state.isFocused
                                          ? "0 0 0 1px #007A99"
                                          : "none",
                                        "&:hover": {
                                          borderColor: state.isFocused
                                            ? "none"
                                            : "2px solid rgba(46, 55, 164, 0.1)",
                                        },
                                        borderRadius: "10px",
                                        fontSize: "14px",
                                        minHeight: "45px",
                                      }),
                                      dropdownIndicator: (base, state) => ({
                                        ...base,
                                        transform: state.selectProps.menuIsOpen
                                          ? "rotate(-180deg)"
                                          : "rotate(0)",
                                        transition: "250ms",
                                        width: "35px",
                                        height: "35px",
                                        zIndex: 9999,
                                      }),
                                      menu: (base) => ({
                                        ...base,
                                        zIndex: 9999, // Set a high z-index value here
                                      }),
                                    }}
                                    isClearable
                                  />
                                </div>
                              </div>
                              <div className="col-12 col-md-4 col-lg-2">
                                <div className="form-group local-forms">
                                  <label>
                                    Department
                                    {/* <span className="login-danger">*</span> */}
                                  </label>
                                  <Select
                                    isLoading={deptLoading}
                                    value={
                                      departmentOption?.find(
                                        (option) =>
                                          option.value === filter.department_id
                                      ) || null
                                    }
                                    onChange={(e) =>
                                      handleFilterChange(
                                        "department_id",
                                        e?.value
                                      )
                                    }
                                    name="department_id"
                                    options={departmentOption}
                                    placeholder="Select department"
                                    components={{
                                      IndicatorSeparator: () => null, // Hide separator line between the dropdown indicator and the control
                                    }}
                                    styles={{
                                      control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        // zIndex: 99999,
                                        borderColor: state.isFocused
                                          ? "none"
                                          : "2px solid rgba(46, 55, 164, 0.1)",
                                        boxShadow: state.isFocused
                                          ? "0 0 0 1px #007A99"
                                          : "none",
                                        "&:hover": {
                                          borderColor: state.isFocused
                                            ? "none"
                                            : "2px solid rgba(46, 55, 164, 0.1)",
                                        },
                                        borderRadius: "10px",
                                        fontSize: "14px",
                                        minHeight: "45px",
                                      }),
                                      dropdownIndicator: (base, state) => ({
                                        ...base,
                                        transform: state.selectProps.menuIsOpen
                                          ? "rotate(-180deg)"
                                          : "rotate(0)",
                                        transition: "250ms",
                                        width: "35px",
                                        height: "35px",
                                        zIndex: 9999,
                                      }),
                                      menu: (base) => ({
                                        ...base,
                                        zIndex: 9999, // Set a high z-index value here
                                      }),
                                    }}
                                    isClearable
                                  />
                                </div>
                              </div>
                              <div className="col-12 col-md-4 col-lg-2">
                                <div className="form-group local-forms">
                                  <label>
                                    Mode Of Payment
                                    {/* <span className="login-danger">*</span> */}
                                  </label>
                                  <Select
                                    value={
                                      modeOfPayment.find(
                                        (option) =>
                                          option.value === filter?.payment_mode
                                      ) || null
                                    }
                                    onChange={(e) =>
                                      handleFilterChange(
                                        "payment_mode",
                                        e?.value
                                      )
                                    }
                                    name="payment_mode"
                                    options={modeOfPayment}
                                    placeholder="Select mode"
                                    components={{
                                      IndicatorSeparator: () => null, // Hide separator line between the dropdown indicator and the control
                                    }}
                                    styles={{
                                      control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        // zIndex: 99999,
                                        borderColor: state.isFocused
                                          ? "none"
                                          : "2px solid rgba(46, 55, 164, 0.1)",
                                        boxShadow: state.isFocused
                                          ? "0 0 0 1px #007A99"
                                          : "none",
                                        "&:hover": {
                                          borderColor: state.isFocused
                                            ? "none"
                                            : "2px solid rgba(46, 55, 164, 0.1)",
                                        },
                                        borderRadius: "10px",
                                        fontSize: "14px",
                                        minHeight: "45px",
                                      }),
                                      dropdownIndicator: (base, state) => ({
                                        ...base,
                                        transform: state.selectProps.menuIsOpen
                                          ? "rotate(-180deg)"
                                          : "rotate(0)",
                                        transition: "250ms",
                                        width: "35px",
                                        height: "35px",
                                        zIndex: 9999,
                                      }),
                                      menu: (base) => ({
                                        ...base,
                                        zIndex: 9999, // Set a high z-index value here
                                      }),
                                    }}
                                    isClearable
                                  />
                                </div>
                              </div>
                              <div className="col-12 col-md-4 col-lg-2">
                                <div className="form-group local-forms">
                                  <label>
                                    Status
                                    {/* <span className="login-danger">*</span> */}
                                  </label>
                                  <Select
                                    value={
                                      statusOptions.find(
                                        (option) =>
                                          option.value === filter.status
                                      ) || null
                                    }
                                    onChange={(e) =>
                                      handleFilterChange("status", e?.value)
                                    }
                                    name="status"
                                    options={statusOptions}
                                    placeholder="Select status"
                                    components={{
                                      IndicatorSeparator: () => null, // Hide separator line between the dropdown indicator and the control
                                    }}
                                    styles={{
                                      control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        // zIndex: 99999,
                                        borderColor: state.isFocused
                                          ? "none"
                                          : "2px solid rgba(46, 55, 164, 0.1)",
                                        boxShadow: state.isFocused
                                          ? "0 0 0 1px #007A99"
                                          : "none",
                                        "&:hover": {
                                          borderColor: state.isFocused
                                            ? "none"
                                            : "2px solid rgba(46, 55, 164, 0.1)",
                                        },
                                        borderRadius: "10px",
                                        fontSize: "14px",
                                        minHeight: "45px",
                                      }),
                                      dropdownIndicator: (base, state) => ({
                                        ...base,
                                        transform: state.selectProps.menuIsOpen
                                          ? "rotate(-180deg)"
                                          : "rotate(0)",
                                        transition: "250ms",
                                        width: "35px",
                                        height: "35px",
                                        zIndex: 9999,
                                      }),
                                      menu: (base) => ({
                                        ...base,
                                        zIndex: 9999, // Set a high z-index value here
                                      }),
                                    }}
                                    isClearable
                                  />
                                </div>
                              </div>
                              <div className="col-12 col-md-5 col-lg-3 mb-2">
                                <div className="d-flex align-items-center">
                                  <button
                                    id="filter-btn"
                                    onClick={handleSubmitFilter}
                                    className="btn btn-primary p-2"
                                  >
                                    Apply Filter
                                  </button>
                                  <button
                                    onClick={handleResetFilter}
                                    className="btn p-2 ms-2"
                                    style={{
                                      border: "1px solid #007A99",
                                      color: "#007A99",
                                      borderRadius: 8,
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Reset
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="page-table-header mb-2">
                      <div className="row align-items-center">
                        <div className="col">
                          <div className="doctor-table-blk">
                            {" "}
                            <div className="d-flex align-items-center">
                              <h3>Invoice List</h3>
                              {showCollection && (
                                <span className="mb-0 ms-2">
                                  Total Collection
                                </span>
                              )}
                              {showCollection && (
                                <h5 className="mb-0 ms-2">{totalCollection}</h5>
                              )}
                            </div>
                            <div className="doctor-search-blk">
                              <div className="add-group">
                                <Link
                                  to="/admin/add-invoice"
                                  className="btn btn-primary add-pluss ms-2"
                                >
                                  <img src={plusicon} alt="#" />
                                </Link>
                                <Link
                                  onClick={refetchInvoice}
                                  id="refetch-btn"
                                  className="btn btn-primary add-pluss ms-2"
                                >
                                  <img src={refreshicon} alt="#" />
                                </Link>
                                <Link
                                  onClick={() => setShowFilter(!showFilter)}
                                  className="btn btn-primary add-pluss ms-2"
                                >
                                  <FilterAltIcon
                                    sx={{
                                      color: "#0097B2",
                                      ":hover": {
                                        color: "white",
                                      },
                                    }}
                                  />
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-auto text-end float-end ms-auto download-grp">
                          <img
                            className=" me-2"
                            onClick={() =>
                              handlePrintInvoice(
                                getAllInvoicesData?.payload?.invoices
                              )
                            }
                            src={pdficon}
                            alt="#"
                            style={{ cursor: "pointer" }}
                          />

                          <img
                            onClick={() =>
                              generateCsv(getAllInvoicesData?.payload?.invoices)
                            }
                            className=" me-2"
                            src={pdficon3}
                            alt="#"
                            style={{ cursor: "pointer" }}
                          />

                          <img
                            onClick={() =>
                              handleShowJson(
                                getAllInvoicesData?.payload?.invoices
                              )
                            }
                            width={"25px"}
                            height={"26px"}
                            src={pdficon5}
                            alt="#"
                            style={{ cursor: "pointer" }}
                          />
                          {/* </Link> */}
                        </div>
                      </div>
                    </div>
                    <div className="table-responsive">
                      <Table
                        loading={invoiceLoader || isRefetching}
                        pagination={{
                          current: page,
                          pageSize: pageSize,
                          total: getAllInvoicesData?.meta?.total_count,
                          showTotal: (total, range) =>
                            `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                          onChange: handlePageChange,
                        }}
                        columns={columns}
                        dataSource={getAllInvoicesData?.payload?.invoices}
                        // rowSelection={rowSelection}
                        rowKey={(record) => record.id}
                        scroll={{ x: "max-content" }}
                        onChange={(val, filter, sorter) => {
                          // console.log(val, filter, sorter, extra);
                          handleTableChange(filter, sorter);
                        }}
                        locale={{
                          triggerDesc: "Sort descending",
                          triggerAsc: "Sort ascending",
                          cancelSort: "Cancel sort",
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            id="delete_patient"
            className="modal fade delete-modal"
            role="dialog"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body text-center">
                  <img src={imagesend} alt="#" width={50} height={46} />
                  <h3>Are you sure want to delete this ?</h3>
                  <div className="m-t-20">
                    {" "}
                    <Link
                      to="#"
                      className="btn btn-white"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </Link>
                    <button
                      onClick={handleDeleteInvoice}
                      type="submit"
                      className="btn btn-danger"
                      data-bs-dismiss="modal"
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default InvoiceList;
